var installedModules = {};
var moduleToHandlerMapping = {
	0: {
		getter: () => (() => (__webpack_require__(1463))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	19: {
		getter: () => (() => (__webpack_require__(1472))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	3772: {
		getter: () => (() => (__webpack_require__(1064))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	4060: {
		getter: () => (() => (__webpack_require__(2686))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4171: {
		getter: () => (() => (__webpack_require__(2669))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.20.40",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "glamor",
	},
	4173: {
		getter: () => (() => (__webpack_require__(2684))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.2.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	4184: {
		getter: () => (() => (__webpack_require__(2670))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "launchdarkly-react-client-sdk",
	},
	4386: {
		getter: () => (() => (__webpack_require__(2685))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.30.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	4513: {
		getter: () => (() => (__webpack_require__(2671))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "npm:react-dnd@^11.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dnd-latest",
	}
};
var initialConsumes = [0,19];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"2": [
		0,
		19
	],
	"3": [
		3772,
		4060,
		4171,
		4173,
		4184,
		4386,
		4513
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}